import { render, staticRenderFns } from "./PriceDetails.vue?vue&type=template&id=47f1afd8&scoped=true"
import script from "./PriceDetails.vue?vue&type=script&lang=js"
export * from "./PriceDetails.vue?vue&type=script&lang=js"
import style0 from "./PriceDetails.vue?vue&type=style&index=0&id=47f1afd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1afd8",
  null
  
)

export default component.exports